import { AUTH_EVENT } from '~/types/auth.event.types'

export function dispatchTokenExpired() {
  window.dispatchEvent(new CustomEvent(AUTH_EVENT.ACCESS_TOKEN_EXPIRED, { detail: { message: 'Access token expired' } }))
  sessionExpired.value = true
}
